import { render, staticRenderFns } from "./MailServer.vue?vue&type=template&id=01d643cc&scoped=true"
import script from "./MailServer.vue?vue&type=script&lang=js"
export * from "./MailServer.vue?vue&type=script&lang=js"
import style0 from "./MailServer.vue?vue&type=style&index=0&id=01d643cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d643cc",
  null
  
)

export default component.exports